/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUgMTIuNDJMNy4yMSAxMS43MUwzLjcxIDguMjFMMTQgOC4yMUwxNCA3LjIxTDMuNzEgNy4yMUw3LjIxIDMuNzFMNi41IDNMMS43OSA3LjcxTDYuNSAxMi40MloiIGZpbGw9ImluaGVyaXQiLz4=";